import * as React from "react";
const SvgHelp24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "black",
        viewBox: "0 0 22 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 11a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-11C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0ZM7.848 6.436A4.84 4.84 0 0 1 11.72 4.5h.429A3.451 3.451 0 0 1 15.6 7.951c0 1.427-.713 2.76-1.9 3.551l-1.255.836a1 1 0 0 0-.445.832v.49h-2v-.49a3 3 0 0 1 1.336-2.496l1.254-.836a2.268 2.268 0 0 0 1.01-1.887c0-.801-.65-1.451-1.451-1.451h-.429a2.84 2.84 0 0 0-2.272 1.136L8.8 8.5 7.2 7.3l.648-.864Zm4.402 9.814a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgHelp24Px;
